import { timeline } from '@/mocks/timeline';
import type { TimelineItem } from '@/pages/home/types';

const items: TimelineItem[] = timeline;

const dotTone = (index: number) => {
  const map = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500'];
  return map[index % 3];
};

const chipTone = (index: number) => {
  const map = [
    'bg-primary-100 text-primary-700',
    'bg-accent-100 text-accent-800',
    'bg-secondary-100 text-secondary-800',
  ];
  return map[index % 3];
};

export default function Timeline() {
  return (
    <section id="timeline" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20 bg-background-100 border-y border-background-200">
      <div className="mb-8 md:mb-10 max-w-2xl">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold text-secondary-800 bg-secondary-100 px-3 py-1.5 rounded-full mb-4">
          <i className="ri-time-line"></i> 吃瓜时间线
        </span>
        <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug mb-3">
          按时间顺序，还原今天发生了什么
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
          话题从出现到回应往往只有几个小时。这条时间线帮你把散落的信息串起来，看清事情的推进节奏。
        </p>
      </div>

      <ol className="relative max-w-3xl">
        <span className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true"></span>
        {items.map((item, index) => (
          <li key={`${item.time}-${item.title}`} className="relative pl-11 md:pl-14 pb-8 last:pb-0">
            <span
              className={`absolute left-0 top-1 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full ${dotTone(
                index,
              )} text-background-50 dark:text-foreground-950 ring-4 ring-background-100`}
            >
              <i className="ri-flashlight-line text-sm md:text-base"></i>
            </span>
            <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
              <div className="flex flex-wrap items-center gap-2 mb-2">
                <span className="font-heading font-black text-foreground-950">{item.time}</span>
                <span className="text-xs text-foreground-500">{item.date}</span>
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${chipTone(index)}`}>
                  {item.type}
                </span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-1.5">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.detail}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}